'use strict';
receiptsByCustomerController.$inject = ['$scope', '$rootScope', '$q', '$interval', 'reportHelper', 'siteService', 'customerService', 'BUSY_MESSAGE'];
angular.module('schoolLinqApp').controller('receiptsByCustomerController', receiptsByCustomerController);

function receiptsByCustomerController($scope, $rootScope, $q, $interval, reportHelper, siteService, customerService, BUSY_MESSAGE) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.busyPromise = $q.all([$scope.vm.loadSites($scope.vm), $scope.vm.loadCustomers($scope.vm)]);

	function getViewModel(moduleName) {
		var model = {
			module: moduleName,
			busyMessage: BUSY_MESSAGE.Loading,

			report: {
				fromDT: moment().startOf('day').add(-1, 'month').toDate(),
				toDT: moment().startOf('day').toDate(),
				site: { Id: 0 },
				customer: { Id: 0 },
				customerId: 0,
				includeVoids: false,
				groupBy: 'Customer',
			},
			selectedCustomer: null,
			sites: [],
			backupSites: [],
			customers: [],
			backupCustomers: [],
			validationErrors: [],
			errors: null,
		};

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			if (model.report.fromDT > model.report.toDT) {
				model.validationErrors.push('From Date cannot be after the To Date.');
				isValid = false;
			}

			return isValid;
		}

		function openReport(model) {
			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			if (!validateReportParams(model)) return false;

			$scope.isReportFinished = false;
			model.busyMessage = BUSY_MESSAGE.GeneratingReport;
			$scope.busyPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var report = {
				FromDT: model.report.fromDT,
				ToDT: model.report.toDT,
				CustomerId: model.report.customer.Id,
				CustomerName: model.report.customer.CustomerName,
				SiteId: model.report.site.Id,
				SiteName: model.report.site.SiteName,
				IncludeVoids: model.report.includeVoids,
				GroupBy: model.report.groupBy,
			};

			reportHelper.getReport($scope, '/api/fundreports/receiptsbycustomerreport', report, 'ReceiptsByCustomerReport.pdf');
		}

		function exportExcel(model) {
			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			if (!validateReportParams(model)) return false;

			$scope.isReportFinished = false;
			model.busyMessage = BUSY_MESSAGE.GeneratingExcelFile;
			$scope.busyPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var report = {
				FromDT: model.report.fromDT,
				ToDT: model.report.toDT,
				CustomerId: model.report.customer.Id,
				CustomerName: model.report.customer.CustomerName,
				SiteId: model.report.site.Id,
				SiteName: model.report.site.SiteName,
				IncludeVoids: model.report.includeVoids,
				GroupBy: model.report.groupBy,
			};

			reportHelper.getExcel($scope, '/api/fundreports/receiptsbycustomerexcel', report, 'ReceiptsByCustomer.xlsx');
		}

		function loadSites(model) {
			return siteService.getSites().then(_.partial(finishLoadingSites, model));

			function finishLoadingSites(model, response) {
				model.sites = response.data.sites;
				model.backupSites = angular.copy(model.sites);
				// if there is only one site available then go ahead and select it for the user.
				if (model.sites.length === 1) {
					model.report.site = model.sites[0];
				} else {
					// if there is more than one site available then add an ALL option to the list.
					model.sites.unshift({ Id: 0, SiteName: 'All' });
				}
				return angular.noop;
			}
		}

		function updateSiteList(model) {
			if (model.report.customerId !== 0) {
				// if Customer is not All then only show Sites that the Customer has access to
				model.busyMessage = BUSY_MESSAGE.Loading;
				$scope.busyPromise = siteService.getSitesForCustomer(model.report.customer.Id).then(_.partial(finishGetSitesForCustomer, model));
			} else {
				model.sites = angular.copy(model.backupSites);
				// if there is only one site available then go ahead and select it for the user.
				if (model.sites.length === 1) {
					model.report.site = model.sites[0];
				} else {
					// if there is more than one site available then add an ALL option to the list.
					model.sites.unshift({ Id: 0, SiteName: 'All' });
				}
			}

			function finishGetSitesForCustomer(model, response) {
				model.sites = response.data.sites;
				// if there is only one site available then go ahead and select it for the user.
				if (model.sites.length === 1) {
					model.report.site = model.sites[0];
				} else {
					// if there is more than one site available then add an ALL option to the list.
					model.sites.unshift({ Id: 0, SiteName: 'All' });
				}
				let found = _.find(model.sites, function (obj) {
					return obj.Id === model.report.site.Id;
				});
				if (found === undefined) model.report.site.Id = 0;
				return angular.noop;
			}
		}

		function loadCustomers(model) {
			return customerService.getCustomers().then(_.partial(finishLoadingCustomers, model));

			function finishLoadingCustomers(model, response) {
				model.customers = response.data.customers;
				model.backupCustomers = angular.copy(model.customers);
				model.customers.unshift({ Id: 0, CustomerName: 'All' });
				return angular.noop;
			}
		}

		function updateCustomerList(model) {
			if (model.report.site.Id !== 0) {
				// if Site is not All then only show Customers that have access to this Site
				model.busyMessage = BUSY_MESSAGE.Loading;
				$scope.busyPromise = customerService.getCustomers(model.report.site.Id).then(_.partial(finishSearchingCustomers, model));
			} else {
				model.customers = angular.copy(model.backupCustomers);
				model.customers.unshift({ Id: 0, CustomerName: 'All' });
			}

			function finishSearchingCustomers(model, response) {
				model.customers = response.data.customers;
				//model.customers = _.where(model.customers, { Active: "Active" });
				model.customers.unshift({ Id: 0, CustomerName: 'All' });
				let found = _.find(model.customers, function (obj) {
					return obj.Id === model.report.customer.Id;
				});
				if (found === undefined) model.report.customerId = 0;
				return angular.noop;
			}
		}

		return angular.extend(model, {
			loadSites: _.partial(loadSites, model),
			updateSiteList: _.partial(updateSiteList, model),
			loadCustomers: _.partial(loadCustomers, model),
			updateCustomerList: _.partial(updateCustomerList, model),
			openReport: _.partial(openReport, model),
			exportExcel: _.partial(exportExcel, model),
		});
	}
}
